import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
import SectionWrapper from '../SectionWrapper/SectionWrapper';
const Container = styled(SectionWrapper) `
  --bgColor: ${brand.white};
  --closeSize: 26px;
  --fgColor: ${brand.base.blue};
  --tintColor: rgba(0, 0, 0, 0.75);
  --shadowColour: rgba(0, 0, 0, 0.05);

  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  place-content: center;
  color: var(--fgColor);
  height: 100%;
  place-content: center;
  place-items: center;
  width: 100%;
  z-index: 999;

  &[data-open='false'] {
    display: none;
  }
`;
const Inner = styled.div `
  position: relative;
  z-index: 1;
  width: calc(100% - 36px);
  height: 100%;
  max-width: 1300px;
  max-height: 90vh;
  background-color: var(--bgColor);
  border-radius: 5px;
  box-shadow: -0.1px -1.1px 1.1px var(--shadowColour), -0.2px 2.7px 3px -0.8px var(--shadowColour),
    -0.4px 6.3px 7.1px -1.7px var(--shadowColour), -0.9px 5px 16.9px -2.5px var(--shadowColour);
  padding: ${fluid(72, 80)} ${fluid(28, 74)} ${fluid(24, 80)};
`;
const Content = styled.div `
  ${scrollbars};

  overflow: auto;
  height: 100%;
  padding-right: 8px;
`;
const ModalStyles = {
    Container,
    Content,
    Inner,
};
export default ModalStyles;
